import { Injectable } from '@angular/core';
import { ComponentStore } from '@ngrx/component-store';
import { CmsState, DEFAULT_STATE, WorkSpaceState,ActionState } from './model';
import { Observable } from 'rxjs';
import { CmsService } from './cms.service';
import { CmsComponentConfig } from './dynamic-component-container/dynamic-model';

/* const DEFAULT_STATE:CmsState = {
  webSiteContents:[],
  selectedSetup:"WebSite",
} */
@Injectable({
  providedIn: 'root'
})
export class CmsStoreService extends ComponentStore<CmsState>{

  constructor(private cmsservice:CmsService) { 
    super(DEFAULT_STATE)
  }

  //Selectors
  readonly cmsComponentConfig$:Observable<CmsComponentConfig> = this.select(state => state.cmsComponentConfig)
  readonly selectedWorkSpace$:Observable<String> = this.select(state => state.workSpaceState);
  readonly firstVisit$:Observable<Boolean> = this.select(state => state.firstVisit);
  readonly action$:Observable<String> = this.select(state => state.action);
  readonly selectedValue$:Observable<any> = this.select(state => state.selectedValue);

  // ViewModel for the component
  readonly vm$ = this.select(
    this.selectedWorkSpace$,
    this.firstVisit$,
    this.action$,
    this.cmsComponentConfig$,
    this.selectedValue$,
    (workSpaceState,firstVisit,action,cmsComponentConfig,selectedValue) => ({
      workSpaceState,
      firstVisit,
      action,
      cmsComponentConfig,
      selectedValue
    })
  );

  //Updaters
    readonly updateWorkSpaceState = this.updater((state:CmsState,menuItemTitle:string) => {
      console.log(state);
      const workSpaceState = menuItemTitle as WorkSpaceState;
      switch (workSpaceState) {
        case WorkSpaceState.WEBSSITES:
          return {
            ...state,
            workSpaceState:WorkSpaceState.WEBSSITES
          }
          break
        case WorkSpaceState.CONTENT:
          return {
            ...state,
            workSpaceState:WorkSpaceState.CONTENT
          }
          break;
        case WorkSpaceState.DATARESOURCE:
          return {
            ...state,
            workSpaceState:WorkSpaceState.DATARESOURCE
          }
          break;
        case WorkSpaceState.SURVEY:
          console.log("Its a survey");
          return {
            ...state,
            workSpaceState:WorkSpaceState.SURVEY
          }
          break;
        case WorkSpaceState.BLOG:
          return {
            ...state,
            workSpaceState:WorkSpaceState.BLOG
          }
          break;
      
        default:
          break;
      }
     
    });

    readonly updateFirstVisit = this.updater((state:CmsState,status:boolean) => {
      return {
        ...state,
        firstVisit:status
      }
    });

    readonly updateAction = this.updater((state:CmsState,action:string) => {
      const actionState = action as ActionState;
      switch (actionState) {
        case ActionState.ADD:
          return {
            ...state,
            action:ActionState.ADD
          }
          break;
        case ActionState.DELETE:
          return {
            ...state,
            action:ActionState.DELETE
          }
          break;
        case ActionState.EDIT:
        return {
          ...state,
          action:ActionState.EDIT
        }
        break;
        case ActionState.FIND:
          return {
            ...state,
            action:ActionState.FIND
          }
          break;
        case ActionState.LIST:
          return {
            ...state,
            action:ActionState.LIST
          }
          break;
        case ActionState.VIEW:
          return {
            ...state,
            action:ActionState.VIEW
          }
        default:
          break;
      }
      
    });

    readonly updateComponentConfig = this.updater((state:CmsState,cmsComponentConfig:CmsComponentConfig) => {
      return {
        ...state,
        cmsComponentConfig:cmsComponentConfig
      }
    });

    readonly updateSelectedValue = this.updater((state:CmsState,selectedValue:any) => {
      return {
        ...state,
        selectedValue:selectedValue
      }
    })

}
